type StoreBridge = {
  getState: () => any;
  dispatch: (action: any) => any;
};

let storeBridge: StoreBridge | null = null;

export const setApiStoreBridge = (bridge: StoreBridge | null): void => {
  storeBridge = bridge;
};

export const getApiStoreState = (): any => storeBridge?.getState();

export const dispatchApiStoreAction = (action: any): void => {
  if (storeBridge && typeof storeBridge.dispatch === 'function') {
    storeBridge.dispatch(action);
  }
};
